import './style.css';

function CARDBOX(props){
    return (
        <div className={`card modern-admin-card bg-card-admin h-100 ${props.className || ''}`}>
            <div className="card-body p-4">
                <div className="d-flex justify-content-between align-items-start mb-3">
                    <div className="card-icon-wrapper">
                        {props.icon ? <i className={`${props.icon} text-primary`}></i> : <i className="fas fa-chart-bar text-primary"></i>}
                    </div>
                    <h6 className="card-category text-uppercase mb-0">{props.header}</h6>
                </div>
                {props.title && <h3 className="card-title mb-2">{props.title}</h3>}
                <div className="card-value mb-0">{props.text}</div>
            </div>
        </div>
    );
}

export default CARDBOX;